<template>
    <div>

        <!-- Stats Start -->
        <div class="row mb-4">
            <div class="col-md-2 d-flex align-items-center">
                <div class=" mt-4">
                    <h3 style="
                            font-size: 16px; 
                            color: #4B4B4B;">QR Management</h3>
                </div>
            </div>
            <div class="col-md-2">
                <div class=" mt-4">
                    <input 
                        class="form-control mr-sm-2" 
                        type="search" 
                        placeholder="Search by Order ID" 
                        aria-label="Search">
                </div>
            </div>
            <div class="col-md-2">
                <div class=" mt-4">
                </div>
            </div>
            <div class="col-md-2">
                <div class=" mt-4">
                </div>
            </div>
            <div class="col-md-2">
                <div class=" mt-4">
                </div>
            </div>
            <div class="col-md-2">
                <div class=" mt-4">
                    <flat-pickr
                        :config="rangePickr"
                        placeholder="Select Date"
                    ></flat-pickr>
                </div>
            </div>
        </div>
        <!-- Stats End -->
        
        <!-- Title & Option Buttons Start -->
        <!-- <div class="mb-4 row">
            <div class="col-md-3">
                <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button>
            </div>
            <div class="col-md-6 text-center" style="display: flex; flex-direction: column-reverse;">
                <h3 class="mb-0">Validasi Pengiriman Barang</h3>
            </div>
            <div class="col-md-3">
                <div class="row">
                    <div class="col-4" style="display: flex; align-items: center;">
                        <span>Filter Tanggal</span>
                    </div>
                    <div class="col-8" style="">
                        <flat-pickr
                            placeholder="Select Date"
                            v-model="selected.date"
                        ></flat-pickr>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- Title & Option Buttons End -->

        <!-- Table Start -->
        <div class="row">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox">
                    <table class="table ahm-table">
                        <thead>
                            <tr>
                                <th>PO Number</th>
                                <th>Request Date</th>
                                <th>Nama Supplier</th>
                                <th>Qty Order</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>0447/PO-MC/04/23</td>
                                <td>03/10/2022 | 12:14</td>
                                <td>Panca Equipment</td>
                                <td>30.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>

                            <tr>
                                <td>0447/PO-MC/04/24</td>
                                <td>03/10/2022 | 11:27</td>
                                <td>Panca Equipment</td>
                                <td>25.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>0447/PO-MC/04/25</td>
                                <td>03/10/2022 | 11:23</td>
                                <td>Panca Equipment</td>
                                <td>15.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>0447/PO-MC/04/26</td>
                                <td>03/10/2022 | 10:59</td>
                                <td>Panca Equipment</td>
                                <td>10.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>0447/PO-MC/04/27</td>
                                <td>03/10/2022 | 10:41</td>
                                <td>Panca Equipment</td>
                                <td>16.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>0447/PO-MC/04/28</td>
                                <td>03/10/2022 | 12:14</td>
                                <td>Panca Equipment</td>
                                <td>13.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                            
                            <tr>
                                <td>0447/PO-MC/04/29</td>
                                <td>03/10/2022 | 11:27</td>
                                <td>Panca Equipment</td>
                                <td>13.000</td>
                                <td>300.000</td>
                                <td>PO Received</td>
                                <td>
                                    <button
                                        class="btn btn-secondary"
                                        style="background-color: #EFEFEF; color: #4B4B4B; border: none;"
                                    >
                                        Lihat Detail
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Table End -->

    </div>
</template>

<script>
// import AktivasiAktivasi from './children/AktivasiAktivasi.vue';
// import ProvinceTable from './children/ProvinceTable.vue';
// import ProviceChart from './children/ProviceChart.vue';
// import highlightStats from './children/HighlightStats.vue'

import qs from 'qs';

// import Map from './children/Map.vue'
import moment from 'moment'
// import Multiselect from 'vue-multiselect';
// import highlightChart from './children/HighlightChart.vue'

export default {
    metaInfo : {
        title : 'Highlights'
    },
    components : {
        // AktivasiAktivasi,
        // Map,
        // Multiselect,
        // ProvinceTable,
        // ProviceChart,
        // highlightStats,
        // highlightChart
    },
    mounted () {
        this.loadStatsData()
        this.loadActivityData()
        this.loadApi(null , null)
    },
    watch : {
        'filter.provinsi' : async function () {
            if(!this.filter.provinsi) {
                this.filter.kabupaten = null;
                this.filter.kecamatan = null;
                this.filter.kelurahan = null;
                this.filter.tps = null;
            }
            else {
                this.filterOptions.kabupaten = await this.$store.getters.getKabupaten(this.filter.provinsi)
                
            }

            this.loadApi(null , null)
                
            // console.log(this.filterOptions)
        },
        'filter.kabupaten' : async function () {
            if(!this.filter.kabupaten) {
                this.filter.kecamatan = null;
                this.filter.kelurahan = null;
                this.filter.tps = null;
            }
            else {
                this.filterOptions.kecamatan = await this.$store.getters.getKecamatan(this.filter.provinsi , this.filter.kabupaten)
                
            }

            this.loadApi(
                [
                    '/api/highlight/kecamatan-stats',
                    '/api/highlight/kelurahan-stats',
                    '/api/highlight/tps-stats'
                ],
                [
                    'kecamatanData',
                    'kelurahanData',
                    'tpsData'
                ]
            )
            
            // console.log(this.filterOptions)
        },
        'filter.kecamatan' : async function () {
            if(!this.filter.kecamatan) {
                this.filter.kelurahan = null;
                this.filter.tps = null;
            }
            else {
                this.filterOptions.kelurahan = await this.$store.getters.getKelurahan(this.filter.provinsi , this.filter.kabupaten , this.filter.kecamatan)
                
            }

            this.loadApi(
                [
                    '/api/highlight/kelurahan-stats',
                    '/api/highlight/tps-stats'
                ],
                [
                    'kelurahanData',
                    'tpsData'
                ]
            )
            
            // console.log(this.filterOptions)
        },
        'filter.kelurahan' : async function () {
            if(!this.filter.kelurahan) {
                this.filter.tps = null;
            }
            else {
                this.filterOptions.tps = await this.$store.getters.getTps(this.filter.provinsi , this.filter.kabupaten , this.filter.kecamatan , this.filter.kelurahan)
                
            }

            this.loadApi(
                [
                    '/api/highlight/tps-stats'
                ],
                [
                    'tpsData'
                ]
            )
            
            // console.log(this.filterOptions)
        },

        'filter.aktivasi.activity' : function () {
            this.loadActivityData()
        },
        'filter.selectedDate' () {
            let split = this.filter.selectedDate.split(" to ");
            this.filter.aktivasi.start_date = split[0];
            this.filter.aktivasi.end_date = split.length > 1 ? split[1] : split[0];

            this.loadActivityData()
        }
    },
    data () {
        let startDate = moment().startOf('month').format("YYYY-MM-DD");
        let currentDate = moment().format("YYYY-MM-DD");

        return {
            moment,
            statsData : null,
            totalRegister : 0,
            kabupatenData : null,
            kecamatanData : null,
            kelurahanData : null,
            tpsData : null,
            activityData : null,
            invokeCenter : null,
            filterOptions : {
                provinsi : this.$store.getters.getFilterOptions.provinsi,
                kabupaten : [],
                kecamatan : [],
                kelurahan : [],
                tps : [],
                scan : [{
                    name : 'Activity By Register',
                    value : 'register'
                }, {
                    name : 'Activity By Scan',
                    value : 'scan'
                }]
            },

            rangePickr: {
                mode: 'range',
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d M Y",
                altInputClass: 'form-control input grey-flatpickr'
            },
            selected : {
                date : `${startDate} to ${currentDate}`
            },
        }
    },
    methods : {
        processCenter (data) {
            this.invokeCenter = data
        },
        async loadActivityData () {
            try {
                let response = await this.$http.get(`/api/highlight/activities?${qs.stringify(this.filter.aktivasi)}`)

                this.activityData = response.data.data
            }
            catch(err) {
                console.log(err)
            }
        },
        getColor (persen) {
            persen = parseFloat(persen)

            if(persen == 0) {
                return '#fbb9b9';
            }

            else if (persen <= 10) {
                return 'rgba(162, 218, 162 , 0.1)'
            }
            else {
                return `rgba(162, 218, 162 , ${(Math.round(persen / 10) * 10) / 100})`;
            }

        },
        async loadStatsData () {
            try {
                let resp = await this.$http.get('/api/highlight/stats')

                this.statsData = resp.data.data[0]

                let total = 0

                for(var i in this.statsData) {
                    if(i.includes('register')) {
                        total += parseInt(this.statsData[i])
                    }

                    // if(i.includes('persen')) {
                    //     this.statsData[i] = '25.00'
                    // }
                }

                this.totalRegister = total
            }
            catch(err) {
                console.log(err)
            }
        },
        async loadApi (url , variable) {
            if(!url) {
                url = [
                    '/api/highlight/kabupaten-stats',
                    '/api/highlight/kecamatan-stats',
                    '/api/highlight/kelurahan-stats',
                    '/api/highlight/tps-stats'
                ]

                variable = [
                    'kabupatenData',
                    'kecamatanData',
                    'kelurahanData',
                    'tpsData'
                ]

                
            }
            // let sumVariable = [
            //     'register_kabupaten',
            //     'register_kecamatan',
            //     'register_desakel',
            //     'register_tps'
            // ]
            let stringFilter = this.initialiseFilter(this.filter)

            try {
                for(var i = 0 ; i < url.length ; i++) {
                    let index = i

                    let response = await this.$http.get(url[index] + '?' + stringFilter)
                    let data = response.data.data

                    this[variable[index]] = data

                    // this[variable[index] + 'Sum'] = data.reduce((total, item) => total + parseInt(item[sumVariable[index]]), 0);
                }
            }
            catch(err) {
                console.log(err)
            }
        }
    }
}
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }
    .statsData {
        padding : 10px 7px;
    }

    .stats {
        font-size: 1.3rem;
        font-weight: 600;
    }

    .bg-kabupaten {
        background-color: darkorange;
    }
    .bg-kecamatan {
        background-color :blueviolet;
    }
    .bg-desakel {
        background-color: darkslategray;
    }
    .bg-tps {
        background-color:dodgerblue;
    }

    .column-region {
        height: 400px;
        overflow-y:scroll;
    }
</style>

<style scoped>
    .horizontal-line {
        border-top: 1px solid #a2a2a2;
        margin: 5px 0 ;
        width: 100%;
        height: 1px;
    }

    .ahm-table thead tr th,
    .table-title {
        font-weight: normal;
        color: #BCBCBC;
    }

    .ahm-table thead tr th,
    .ahm-table tbody tr td {
        vertical-align: middle;
        font-size: 14px;
    }

    .ahm-table .no-border td {
        border: 0;
        padding: 5px;
    }

    .ahm-button-circular {
        width: 40px; /* Set the width and height to the same value for a perfect circle */
        height: 40px;
        border-radius: 50%; /* Makes the button circular */
        background-color: #D8E4FF; /* Sets the background color */
        padding: 10px 20px; /* Adjust padding to fit your content */
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: none;
        outline: none;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
    }
</style>